import { render, staticRenderFns } from "./modal-info.vue?vue&type=template&id=4495df74&scoped=true"
import script from "./modal-info.vue?vue&type=script&lang=js"
export * from "./modal-info.vue?vue&type=script&lang=js"
import style0 from "./modal-info.vue?vue&type=style&index=0&id=4495df74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495df74",
  null
  
)

export default component.exports